import { DSRedirect } from 'shared-definitions/types'
import { ApiResponseRedirect } from 'data-source/types.wp'
import { redirectMapper } from 'data-source/mappers/redirectMapper'

export function codecRedirect(raw: ApiResponseRedirect): DSRedirect | null {
  if ('redirect' in raw) {
    return redirectMapper(raw)
  }
  return null
}
